import { useEffect, useState } from "react"

import { IEntityLookupData } from "../../models"
import { Typeahead } from "react-bootstrap-typeahead"
import clsx from "clsx"
import { useLazyGetLookupAttributeDataQuery } from "../../services"
import { useParams } from "react-router-dom"

export const LookupAttribute = ({
    attributeId,
    value,
    readOnly,
    className,
    onChange,
    onBlur,
}: {
    attributeId: string,
    value?: string,
    required?: boolean,
    placeholder?: string,
    readOnly?: boolean,
    className?: string,
    onChange: (value: any) => void,
    onBlur: () => void
}) => {
    const { siteId } = useParams()
    const [getAttributeData, { data, isLoading, isSuccess, isError }] = useLazyGetLookupAttributeDataQuery()
    const [entities, setLookupData] = useState<IEntityLookupData[]>([]);

    useEffect(() => {
        if (!siteId) return;

        getAttributeData({siteId, attributeId})
        // eslint-disable-next-line
    }, [siteId])

    useEffect(() => {
        if (isSuccess && data)
            setLookupData(data)
        // eslint-disable-next-line
    }, [isSuccess, data])

    if (isError) {
        <span className='alert-info' style={{ display: 'block' }}>
            Failed to load lookup data
        </span>
    }

    const handleOnChange = (selected: Record<string, any>) => {
        const value = selected[0];
        if (value)
            onChange(`${value["id"]}`);
        else
            onChange(undefined);
    }

    return (
        <div className={clsx(className, "field-group")}>
            <Typeahead
                id="attribute"
                labelKey={option => `${(option as any).name || (option as any).id || ''}`}
                disabled={readOnly}
                className="custom-typeahead typeahead-sm"
                isLoading={isLoading}
                clearButton={true}
                options={entities}
                onChange={handleOnChange}
                onBlur={onBlur}
                selected={entities?.filter(p => `${p.id}` === value)}
            />
        </div>
    )
}

